if (!customElements.get('feature-products-swiper')) {
  class FeatureProductsSwiper extends HTMLElement {
     constructor() {
      super();
      this._swiperInstance = null;
      this._swiperContainer = this;
      this.slideCount = this._swiperContainer.querySelectorAll('.swiper-slide').length;

      const isMobile = `(max-width: 768px)`;
      const isMobileMQL = window.matchMedia(isMobile);

      isMobileMQL.addEventListener('change', (event) => {
        this.initSlider();
      });
      this.initSlider();
    }

     initSlider() {
        const pagination = this.querySelector(`.swiper-pagination`);
        const swiperConfig = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            direction: "horizontal",
            breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                pagination: {
                    el: pagination
                },
            },
            769: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            990: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: this.slideCount > 4 ? 4.2 : 4,
                spaceBetween: 20,
            },
            }
        };

        this._swiperInstance = new Swiper(this._swiperContainer, swiperConfig);
     }

  }


  customElements.define('feature-products-swiper', FeatureProductsSwiper);
}